'use client';

import { usePageLayout } from '@libs/common-next';
import { Badge, LoadingIndicator, TextLink } from '@petsmart-ui/sparky';
import type { StoreItemProps } from '@app/hcp/components/StoreDirectory';
import { setStoreCookie } from '@libs/shared-ui/utils';

export default function MyStoreBadge({ store }: Readonly<StoreItemProps>) {
    const {
        favoriteStore: { store: myStore, isLoading },
        setSelectedStore,
        setFavoriteStore,
    } = usePageLayout();

    const showBadge =
        String(store.StoreNumber) === String(myStore?.StoreNumber);
    const setMyStore = () => {
        // update cookie
        setStoreCookie(store.StoreNumber);

        // update local storage and user session state and do optimistic rendering
        setSelectedStore({
            isLoading: false,
            store,
        });
        setFavoriteStore({
            isLoading: false,
            store,
        });
    };

    if (isLoading) {
        return <LoadingIndicator iconSize="2xs" />;
    }

    if (showBadge) {
        return <Badge text="My store" />;
    }

    return <TextLink onClick={setMyStore}>Set as my store</TextLink>;
}
